import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Fragment, useEffect, useState } from "react";
import { MEDIA_ORIGIN } from "../../utils/Environment";
import LoadingSpinner from "../UI/LoadingSpinner";
import { getRelatedResourceList } from "../../lib/api";
import NoResults from '../../pages/NoResults';

const ResourceDetailContent = () => {
  window.scrollTo(0, 0);
  const history = useHistory();
  const tid = useParams().id;
  const [isLoading, setIsLoading] = useState(true);
  const [relatedAppList, setRelatedAppList] = useState();
  const [noResults, setNoResults] = useState('');

  const handleRelatedAppList = (tid) => {
    getRelatedResourceList(tid)
      .then((response) => {
        if(response.length > 0) {
          setRelatedAppList(response);
        } else {
          setNoResults(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false)
      })
  }

  useEffect(() => {
    handleRelatedAppList(tid);
  }, [tid]);

  const goBackNavigation = () => {
    history.go(-1)
  }

  const goToAppDetailPage = (url) => {
    history.push(`/appdetail${url}`)
  }
  
  return (
    <div className="grow">
      {isLoading && (
        <div className="parentDisable">
          <LoadingSpinner />
        </div>
      )}
    <Fragment>
      <section className="section appDetails">
        <div className="px-5 sm:px-5 md:px-5 lg:px-14 py-5 sm:py-5 md:py-5 lg:py-8">
          <div className="flex items-center gap-3 cursor-pointer" onClick={goBackNavigation}>
            <div className="backIconHolder">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" className="size-6 sm:size-8">
                <path d="M20.1201 26.5604L11.4268 17.8671C10.4001 16.8404 10.4001 15.1604 11.4268 14.1338L20.1201 5.44043" stroke="#0057B8" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <p className="text-[#333] text-lg leading-[30px] sm:text-2xl sm:leading-9 barlowBold uppercase tracking-[-0.25px]">BACK</p>
          </div>
        </div>
      </section >
      <section className="section otherResourcesSection">
        <div className="px-5 sm:px-5 md:px-5 lg:px-14">
          {relatedAppList && <div className="otherResources">
            <h4 className="subTitle text-[#000] barlowBold text-lg leading-[22px] sm:text-xl sm:leading-6">Related Resources</h4>
            <div className="mt-6">
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-14 gap-y-6 sm:gap-y-12 *:cursor-pointer">
                {relatedAppList.map((relatedApp, key) => <div className="app" key={key} onClick={() => goToAppDetailPage(relatedApp.slug_url)}>
                  <div className="grid grid-cols-[auto,1fr] gap-4 sm:gap-6">
                    <div className="appIconHolder w-12 sm:w-[72px]">
                      <img src={`${MEDIA_ORIGIN}${relatedApp.icon}`} className="w-full" alt="course icon" />
                    </div>
                    <div className="appInfo flex flex-col gap-1 sm:gap-2 justify-center">
                      <h6 className="appTitle text-[#333] text-base leading-5 sm:text-lg font-medium sm:leading-6">{relatedApp.title}</h6>
                      <p className="text-[#333] text-xs leading-4 sm:text-base sm:leading-5 font-normal md:max-w-[70%] max-w-full lg:max-w-[80%]">{relatedApp.summary}</p>
                    </div>
                  </div>
                </div>)}
              </div>
            </div>
          </div>
          }
          {noResults &&  <NoResults /> }
        </div>
      </section>
    </Fragment> 
    </div >
  );
};

export default ResourceDetailContent;
